__turbopack_context__.v({
  "slice": "BrandedStoreSliceZone-module-scss-module__G3SNrG__slice",
});
